import { useEffect } from 'react';
import { findByKey } from '@/widget/domain/conversation';
import { isOnline } from '@/widget/domain/operator';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { useStore } from 'zustand';

export default function useConversationHeader() {
  const { store } = useChatWidgetContext();
  const conversations = useStore(store, (state) => state.conversations);
  const operators = useStore(store, (state) => state.operators);
  const operatorsLoaded = useStore(store, (state) => state.operatorsLoaded);
  const activeConversationKey = useStore(store, (state) => state.activeConversationKey);
  const subscription = useStore(store, (state) => state.widgetSubscription);

  const {
    previousMode,
    setActiveConversationKey,
    setMessages,
    setMode,
    setDelayedMessage,
    setTemplateToStart,
  } = store.getState();

  const currentOperators = findByKey(conversations, activeConversationKey)?.operators?.filter((o) => isOnline(o, operators)) || [];

  useEffect(() => {
    if (operatorsLoaded) { return; }

    subscription.send({
      action_name: 'find_online_operators',
    });
  }, [operatorsLoaded, subscription]);

  const returnFromConversation = () => {
    setActiveConversationKey(null);
    setMessages([]);
    setDelayedMessage(null);
    setTemplateToStart(null);
    setMode(previousMode);
  };

  return {
    currentOperators,
    onlineOperators: operators,
    returnFromConversation,
  };
}
